import React, {
  type ReactNode,
  createContext,
  useContext,
  useState,
} from 'react';

interface FlexAnimationContextType {
  leftVisible: boolean;
  rightVisible: boolean;
  leftWidth: string;
  rightWidth: string;
  setLeftVisible: (visible: boolean) => void;
  setRightVisible: (visible: boolean) => void;
  setLeftWidth: (width: string) => void;
  setRightWidth: (width: string) => void;
}

const FlexAnimationContext = createContext<
  FlexAnimationContextType | undefined
>(undefined);

export const useFlexAnimation = (): FlexAnimationContextType => {
  const context = useContext(FlexAnimationContext);
  if (context === undefined) {
    throw new Error(
      'useFlexAnimation must be used within a FlexAnimationProvider'
    );
  }
  return context;
};

interface FlexAnimationProviderProps {
  children: ReactNode;
  initialLeftWidth?: string;
  initialRightWidth?: string;
}

export const FlexAnimationProvider: React.FC<FlexAnimationProviderProps> = ({
  children,
  initialLeftWidth = '50%',
  initialRightWidth = '50%',
}) => {
  const [leftVisible, setLeftVisible] = useState(true);
  const [rightVisible, setRightVisible] = useState(true);
  const [leftWidth, setLeftWidth] = useState(initialLeftWidth);
  const [rightWidth, setRightWidth] = useState(initialRightWidth);

  return (
    <FlexAnimationContext.Provider
      value={{
        leftVisible,
        rightVisible,
        setLeftVisible,
        setRightVisible,
        leftWidth,
        rightWidth,
        setLeftWidth,
        setRightWidth,
      }}
    >
      {children}
    </FlexAnimationContext.Provider>
  );
};
